import { Anchor, Text } from "@mantine/core";
import { Link } from "react-router";

import { paths } from "@/config/paths";
import { formatCurrency } from "@/utils/formatEuro";

import type { LabelValueProps } from "@/components/elements";
import type { AuctionCarTransaction } from "@/types/auctions";
import type { MarketCar } from "@/types/market";
import type { TFunction } from "i18next";
import type { JSX } from "react/jsx-runtime";

export function getColumns1(
  t: TFunction<"translation", undefined>,
  renderEstimate: () => JSX.Element,
  renderPrice: (value?: number) => JSX.Element,
  currentTransaction: AuctionCarTransaction
): LabelValueProps[] {
  return [
    {
      label: t("components.AuctionCarCard.estimate"),
      value: renderEstimate(),
      size: "md",
    },
    {
      label: t("components.AuctionCarCard.net_to_seller"),
      value: renderPrice(currentTransaction.net_to_seller),
      size: "md",
    },
  ];
}

export function getColumns2(
  t: TFunction<"translation", undefined>,
  currentTransaction: AuctionCarTransaction,
  notAvailable: string,
  green: string,
  marketCar: MarketCar | undefined
): LabelValueProps[] {
  return [
    {
      label: t("components.AuctionCarCard.vin"),
      value: currentTransaction.vin ? (
        <Anchor
          component={Link}
          to={paths.app.vin.car.getHref(currentTransaction.vin)}
          fz="sm"
          fw={500}
        >
          {currentTransaction.vin}
        </Anchor>
      ) : (
        notAvailable
      ),
      size: "md",
    },
    {
      label: t("components.AuctionCarCard.carburate_estimate"),
      value: (
        <Text fz="sm" c={green} fw={500}>
          {formatCurrency(marketCar?.current_valuation) || notAvailable}
        </Text>
      ),
      size: "md",
    },
  ];
}

export function getColumns3(
  t: TFunction<"translation", undefined>,
  renderCondition: (conditionVal?: any) => JSX.Element,
  currentTransaction: AuctionCarTransaction,
  renderPrice: (value?: number) => JSX.Element
): LabelValueProps[] {
  return [
    {
      label: t("components.AuctionCarCard.condition"),
      value: renderCondition(currentTransaction.condition),
      size: "md",
    },
    {
      label: t("components.AuctionCarCard.hammer_price"),
      value: renderPrice(currentTransaction.hammer_price),
      size: "md",
    },
  ];
}
